import { SamplesBrand } from 'constants/brands';
import React from 'react';
import styled from 'styled-components';
import { ProductHeader, spacing, Nav } from '@landr/maestro';
import { useAuthentication } from 'components/AuthenticationProvider/AuthenticationProvider';
import { RouterLink } from 'components/CommonUi';
import { getIsDAWPlugin } from 'helpers/executionEnvironment';
import { useToLocalizedPath } from 'hooks/useToLocalizedPath/useToLocalizedPath';
import { PublicNavigation, AuthenticatedNavigation } from './components';

const StyledProductHeader = styled(ProductHeader)`
    padding: ${spacing('lg')} 0 ${spacing('xl')};
    ${({ theme }): string => theme.breakpoint('md')`
        padding: ${spacing('sm')} 0 ${spacing('sm')};
    `}
`;

export const MainNavigation = () => {
    const isDAWPlugin = getIsDAWPlugin();
    const { isAuthenticated } = useAuthentication();
    const toLocalizedPath = useToLocalizedPath();
    const path = toLocalizedPath('/');

    return (
        <StyledProductHeader>
            <ProductHeader.Name>
                <Nav.Link as={RouterLink} to={path}>
                    {SamplesBrand}
                </Nav.Link>
            </ProductHeader.Name>
            <ProductHeader.Collapse triggerLabel="Menu">
                {({ onClose }: { onClose: () => void }) => (
                    <>
                        <PublicNavigation
                            onClick={onClose}
                            isDAWPlugin={isDAWPlugin}
                        />
                        {isAuthenticated && (
                            <AuthenticatedNavigation onClick={onClose} />
                        )}
                    </>
                )}
            </ProductHeader.Collapse>
        </StyledProductHeader>
    );
};
